$(document).ready(function(){
	$(document).delegate('*[data-toggle="lightbox"]', 'click', function(event) {
		event.preventDefault();
		$(this).ekkoLightbox();
	});
});
$(window).load(function() {
	if ($('.grid').length) {
	var msnry = new Masonry( '.grid', {
		itemSelector: '.grid-item',
		//columnWidth: 400,
		fitWidth: true,
		gutter: 12,
	});
	msnry.once('layoutComplete', function() {
		$(".autoFadeIn").css('opacity', 1);
	});
	msnry.layout();
	}
});